import { type UseQueryResult, useQuery } from 'react-query';
import { StatusDropdownAppServicesService } from '../../services/wealthlane-award-services';

const useGetAwardAdjustmentMethod = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const awardAdjustmentMethod = useQuery(
    ['getAwardAdjustmentMethod'],
    async () => {
      return await handleRequest(
        StatusDropdownAppServicesService.getApiAwardApiAppStatusDropdownAppServicesAwardAdjustmentMethod()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.text ?? '',
            value: item.value ?? '',
          };
        });
      },
    }
  );

  return awardAdjustmentMethod;
};

export default useGetAwardAdjustmentMethod;
